import { Link } from 'react-router-dom';
import { articleList } from '@/mocks/article';
import Breadcrumb from '@/components/base/Breadcrumb';
import PageSEO from '@/components/base/PageSEO';

export default function ArticleList() {
  return (
    <PageSEO
      title="文章中心 - 17c使用教程与功能指南 | 17c官网"
      description="浏览17c平台最新文章，涵盖使用教程、功能详解、进阶技巧、实战案例和更新动态，帮助您全面掌握17c的各项功能。"
      keywords="17c教程,17c文章,17c指南,17c使用技巧,17c更新"
      canonicalPath="/article"
    >
      <section className="pt-24 pb-16 md:pt-28 md:pb-24 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto fade-in-up">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '文章中心' },
            ]}
          />

          <div className="text-center mb-10">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              文章中心
            </h1>
            <p className="text-foreground-600 text-sm md:text-base">
              浏览最新文章，了解 17c 的使用技巧、功能更新和行业洞察
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articleList.map((article, idx) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group block rounded-lg bg-background-100 border border-background-200/60 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer fade-in-up"
                style={{ animationDelay: `${0.1 + idx * 0.1}s` }}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex flex-wrap items-center gap-2 mb-3">
                    <span className="px-2.5 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700">
                      {article.category}
                    </span>
                    {article.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2.5 py-0.5 text-xs rounded-full bg-accent-100 text-accent-700"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                    {article.summary}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span>{article.date}</span>
                    <span>{article.readTime} 阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PageSEO>
  );
}